/* Zenimal product pages: media tabs, photos, options, buy bar, previews. Sound only starts on a press. */
(function () {
  'use strict';
  if (window.__zenPdpLoaded) { return; }
  window.__zenPdpLoaded = true;

  // Tabs with arrow keys (WAI-ARIA tabs pattern).
  function tabs(list, onSelect) {
    var btns = [].slice.call(list.querySelectorAll('[role="tab"]'));
    function select(b, focus) {
      btns.forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; }
      });
      if (focus) { b.focus(); }
      if (onSelect) { onSelect(b); }
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(b, false); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') { n = btns[(i + 1) % btns.length]; }
        if (e.key === 'ArrowLeft') { n = btns[(i - 1 + btns.length) % btns.length]; }
        if (e.key === 'Home') { n = btns[0]; }
        if (e.key === 'End') { n = btns[btns.length - 1]; }
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  function stopHeroSound() {
    var s = document.querySelector('[data-zp-hero] [data-stop]:not([hidden])');
    if (s) { s.click(); }
  }

  function initHero(root) {
    var tl = root.querySelector('.zp-tabs');
    if (tl) { tabs(tl, function (b) { if (b.getAttribute('data-zp-tab') === 'photos') { stopHeroSound(); } }); }

    // A press on the device stops any preview playing further down, so two sounds never overlap.
    root.addEventListener('click', function (e) { if (e.target.closest('[data-key]')) { stop(); } });

    // Photos: thumbnails move the strip, the strip moves the thumbnails.
    var g = root.querySelector('[data-zp-gallery]');
    if (g) {
      var strip = g.querySelector('.zp-slides'), thumbs = [].slice.call(g.querySelectorAll('[data-zp-go]'));
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var n = parseInt(t.getAttribute('data-zp-go'), 10) - 1;
          var slide = strip.children[n];
          if (slide) { strip.scrollTo({ left: slide.offsetLeft - strip.offsetLeft, behavior: 'smooth' }); }
          thumbs.forEach(function (x) { if (x === t) { x.setAttribute('aria-current', 'true'); } else { x.removeAttribute('aria-current'); } });
        });
      });
      var tm;
      strip.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () {
          var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          thumbs.forEach(function (x, k) { if (k === i) { x.setAttribute('aria-current', 'true'); } else { x.removeAttribute('aria-current'); } });
        }, 80);
      });
    }

    // Options shown as cards update the theme's add to cart form.
    var form = root.querySelector('[data-zp-form] form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var prices = [].slice.call(root.querySelectorAll('[data-zp-price]'));
    root.querySelectorAll('[data-zp-variants] input').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) { return; }
        if (idInput) { idInput.value = r.value; }
        prices.forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); window.history.replaceState({}, '', u); } catch (e) {}
      });
    });

    // Slim buy bar: shows once the main add to cart button is out of view, hides near the footer.
    var bar = root.querySelector('[data-zp-bar]'), main = root.querySelector('[data-zp-form]');
    if (bar && main && 'IntersectionObserver' in window) {
      var past = false, footerIn = false;
      function sync() {
        var on = past && !footerIn;
        bar.hidden = false;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }
      // A scroll check, not only an observer, so a jump straight back to the top hides it too.
      var ticking = false;
      function check() { ticking = false; var r = main.getBoundingClientRect(); var p = r.bottom < 0; if (p !== past) { past = p; sync(); } }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      var foot = document.getElementById('Page-Footer') || document.querySelector('footer');
      if (foot) { new IntersectionObserver(function (es) { footerIn = es[0].isIntersecting; sync(); }).observe(foot); }
      bar.querySelector('[data-zp-bar-add]').addEventListener('click', function () {
        var btn = form && form.querySelector('[type="submit"]');
        if (!form || !btn) { return; }
        if (form.requestSubmit) { form.requestSubmit(btn); } else { btn.click(); }
      });
    }
  }

  // Previews in the "hear it" section: one sound at a time, with a thin progress line.
  var audio = null, playing = null, raf = 0;
  function stop() {
    cancelAnimationFrame(raf);
    if (audio) { try { audio.pause(); } catch (e) {} }
    if (playing) {
      playing.setAttribute('aria-pressed', 'false');
      playing.style.removeProperty('--p');
      var bar = playing.closest('.zp-track').querySelector('.zp-t-bar span');
      if (bar) { bar.style.width = '0'; }
      var out = nowOut(playing);
      if (out) { out.textContent = ''; }
    }
    audio = null; playing = null;
  }
  function tick() {
    if (!audio || !playing) { return; }
    var bar = playing.closest('.zp-track').querySelector('.zp-t-bar span');
    if (audio.duration) {
      var pct = Math.min(100, audio.currentTime / audio.duration * 100);
      if (bar) { bar.style.width = pct + '%'; }
      playing.style.setProperty('--p', pct + '%');
    }
    raf = requestAnimationFrame(tick);
  }
  function nowOut(b) { var c = b.closest('.zp-coll'); return c ? c.querySelector('[data-zp-now-out]') : null; }
  function initHear(root) {
    var tl = root.querySelector('.zp-coll-tabs');
    if (tl) { tabs(tl, function () { stop(); }); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.zp-play[data-zp-src]');
      if (!b) { return; }
      if (playing === b) { stop(); return; }
      stop(); stopHeroSound();
      var a = new Audio(b.getAttribute('data-zp-src'));
      a.volume = 0.8; audio = a; playing = b;
      b.setAttribute('aria-pressed', 'true');
      var out = nowOut(b);
      if (out && b.getAttribute('data-zp-now')) { out.textContent = 'Playing ' + b.getAttribute('data-zp-now'); }
      a.addEventListener('ended', function () { if (audio === a) { stop(); } });
      var p = a.play(); if (p && p.catch) { p.catch(function () { if (audio === a) { stop(); } }); }
      raf = requestAnimationFrame(tick);
    });
  }

  // In the box: Details and Safety open in place, one at a time.
  function initBox(root) {
    var pills = [].slice.call(root.querySelectorAll('button.zp-pill[aria-controls]'));
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        pills.forEach(function (x) {
          var on = x === b && open;
          x.setAttribute('aria-expanded', String(on));
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) { p.hidden = !on; }
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-zp-box]').forEach(initBox);
    document.querySelectorAll('[data-zp-hero]').forEach(initHero);
    document.querySelectorAll('[data-zp-hear]').forEach(initHear);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();